import ArrowIcon from "../../assets/img/icons/arrow-acc.svg";
import { StyledCalendarFilters } from "../../styles/StyledCalendar";
import { Checkbox } from "../../components/Checkbox";
import { PropTypes } from "prop-types";
import { useState } from "react";

export default function CalendarFilters({
	isUnitsListLoading,
	choosenUnits,
	unitsListData,
	setChoosenUnits,
	choosenFilterDates,
	setChoosenFilterDates,
	choosenFilterStatus,
	setChoosenFilterStatus,
}) {
	const [unitsDropdownCollapsed, setUnitsDropdownCollapsed] = useState(false);
	const [datesDropdownCollapsed, setDatesDropdownCollapsed] = useState(false);
	const [statusDropdownCollapsed, setStatusDropdownCollapsed] = useState(false);

	const datesFiltersList = {
		decisionDate: "Decision Date",
		validFrom: "Valid from",
		validTo: "Valid to",
		review: "Review",
	};

	const statusFiltersList = {
		1: "Ongoing",
		2: "Done",
		3: "Archive",
	};

	return (
		<StyledCalendarFilters>
			<div className={`dateFilters${!datesDropdownCollapsed ? " active" : ""}`}>
				<h3 onClick={() => setDatesDropdownCollapsed(!datesDropdownCollapsed)}>
					<i>
						<img src={ArrowIcon} alt="Arrow" />
					</i>
					Dates
				</h3>
				<div>
					{Object.keys(datesFiltersList).map((e, i) => {
						if (choosenFilterDates[e]) {
							return (
								<label className="dateFilter" key={i} htmlFor={`dateFilter-${i}`}>
									<Checkbox
										name={`dateFilter-${i}`}
										changeHandler={() => {
											setChoosenFilterDates({ ...choosenFilterDates, [e]: false });
										}}
										value={true}
									/>
									{datesFiltersList[e]}
								</label>
							);
						}
					})}
					{Object.keys(datesFiltersList).map((e, i) => {
						if (!choosenFilterDates[e]) {
							return (
								<label className="dateFilter" key={i} htmlFor={`dateFilter-${i}`}>
									<Checkbox
										name={`dateFilter-${i}`}
										changeHandler={() => {
											setChoosenFilterDates({ ...choosenFilterDates, [e]: true });
										}}
										value={false}
									/>
									{datesFiltersList[e]}
								</label>
							);
						}
					})}
				</div>
			</div>
			<div className={`statusFilters${!statusDropdownCollapsed ? " active" : ""}`}>
				<h3 onClick={() => setStatusDropdownCollapsed(!statusDropdownCollapsed)}>
					<i>
						<img src={ArrowIcon} alt="Arrow" />
					</i>
					Decision status
				</h3>
				<div>
					{Object.keys(statusFiltersList).map((e, i) => {
						if (choosenFilterStatus[e]) {
							return (
								<label className="dateFilter" key={i + 3} htmlFor={`dateStatus-${i + 3}`}>
									<Checkbox
										name={`dateStatus-${i + 3}`}
										changeHandler={() => {
											setChoosenFilterStatus({ ...choosenFilterStatus, [e]: false });
										}}
										value={true}
									/>
									{statusFiltersList[e]}
								</label>
							);
						}
					})}
					{Object.keys(statusFiltersList).map((e, i) => {
						if (!choosenFilterStatus[e]) {
							return (
								<label className="dateFilter" key={i + 3} htmlFor={`dateStatus-${i + 3}`}>
									<Checkbox
										name={`dateStatus-${i + 3}`}
										changeHandler={() => {
											setChoosenFilterStatus({ ...choosenFilterStatus, [e]: true });
										}}
										value={false}
									/>
									{statusFiltersList[e]}
								</label>
							);
						}
					})}
				</div>
			</div>
			{!isUnitsListLoading && choosenUnits && (
				<div className={`units${!unitsDropdownCollapsed ? " active" : ""}`}>
					<h3 onClick={() => setUnitsDropdownCollapsed(!unitsDropdownCollapsed)}>
						<i>
							<img src={ArrowIcon} alt="Arrow" />
						</i>
						Units
					</h3>
					<div>
						<label className="unit" htmlFor="choosenUnit-all">
							<Checkbox
								name="choosenUnit-all"
								changeHandler={() => {
									const tempObj = {};

									Object.keys(choosenUnits).map((e) => {
										tempObj[e] = false;
									});

									setChoosenUnits({ ...tempObj, all: true });
								}}
								value={choosenUnits.all}
							/>
							All
						</label>
						{unitsListData.map((e, i) => {
							if (choosenUnits[e.id]) {
								return (
									<label className="unit" key={i} htmlFor={`choosenUnit-${i}`}>
										<Checkbox
											name={`choosenUnit-${i}`}
											changeHandler={() => {
												setChoosenUnits({ ...choosenUnits, [e.id]: false, all: false });
											}}
											value={true}
										/>
										{e.name}
									</label>
								);
							}
						})}
						{unitsListData.map((e, i) => {
							if (!choosenUnits[e.id]) {
								return (
									<label className="unit" key={i} htmlFor={`choosenUnit-${i}`}>
										<Checkbox
											name={`choosenUnit-${i}`}
											changeHandler={() => {
												setChoosenUnits({ ...choosenUnits, [e.id]: true, all: false });
											}}
											value={false}
										/>
										{e.name}
									</label>
								);
							}
						})}
					</div>
				</div>
			)}
		</StyledCalendarFilters>
	);
}

CalendarFilters.propTypes = {
	isUnitsListLoading: PropTypes.bool,
	choosenUnits: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
	unitsListData: PropTypes.array,
	setChoosenUnits: PropTypes.func,
	choosenFilterDates: PropTypes.any,
	setChoosenFilterDates: PropTypes.func,
	choosenFilterStatus: PropTypes.any,
	setChoosenFilterStatus: PropTypes.func,
};
